import React from 'react';
import PropTypes from 'prop-types';
import RoomTypeCode from '../SetupItemLookup/RoomTypeCode';

const BundlePartOfUpgradeCaption = ({roomTypeId}) => (
  <span>Part of <RoomTypeCode id={roomTypeId}/> upgrade</span>
);

BundlePartOfUpgradeCaption.propTypes = {
  roomTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default BundlePartOfUpgradeCaption;
